"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SetReflectionRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { setReflection } from "../api/setReflection";
import { thoughtKeys } from "../queries/keys";

export default function useSetReflectionMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: SetReflectionRequest) =>
      setReflection(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: thoughtKeys.all });
    },
  });
}
